// extracted by mini-css-extract-plugin
export var container = "_5h-1";
export var editor = "_5h-2";
export var resizable = "_5h-3";
export var wrapper = "_5h-0";